import { render, staticRenderFns } from "./YeDetail.vue?vue&type=template&id=9ca2853e&scoped=true&"
import script from "./YeDetail.vue?vue&type=script&lang=js&"
export * from "./YeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca2853e",
  null
  
)

export default component.exports